export const SIGNUP_OR_SIGNIN_POLICY = 'B2C_1A_B2CSIGNUPORSIGNIN';
export const GRANT_TYPE = 'authorization_code';
